export default __webpack_public_path__ + "static/media/plus.1a305e37.svg";